import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
// import { Observable } from 'rxjs/Observable';

// import { Product } from '../products/product';

import { CartItem } from '../cart/cart-item';
import { CartService } from '../cart/cart.service';
import { CheckoutService } from '../checkout/checkout.service';
import { LoggingService } from '../loging/logging.service';
export class OrderSummaryComponent implements OnInit {
    cartItems: CartItem[];
    cartGrandTotal: number;
/**
 * @param {?} cartService
 * @param {?} location
 * @param {?} router
 * @param {?} checkoutService
 * @param {?} loggingService
 */
constructor(
private cartService: CartService,
private location: Location,
private router: Router,
private checkoutService: CheckoutService,
private loggingService: LoggingService
    ) {
        this.loggingService.log('this.checkoutService.checkoutInfo');
        this.loggingService.log(this.checkoutService.checkoutInfo);
    }
/**
 * @return {?}
 */
ngOnInit() {
        this.cartItems = this.cartService.get();
        this.cartGrandTotal = this.cartService.getTotalBeforeTax();
    }
/**
 * @param {?} index
 * @return {?}
 */
decreaseQuantity(index: number) {
        this.cartService.decreaseQuantity(index);
        this.cartItems = this.cartService.get();
        this.cartGrandTotal = this.cartService.getTotalBeforeTax();
        this.cartItems;
    }
/**
 * @param {?} index
 * @return {?}
 */
increaseQuantity(index: number) {
        this.cartService.increaseQuantity(index);
        this.cartItems = this.cartService.get();
        this.cartGrandTotal = this.cartService.getTotalBeforeTax();
    }
/**
 * @return {?}
 */
goBack(): void {
        this.location.back();
    }
/**
 * @return {?}
 */
submitOrder(): void {
        this.checkoutService.getCreditCardToken2();
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'my-order-summary',
    template: "<div class=\"cart\"> <h2>Order Summary</h2> <ul class=\"cart-items\"> <li *ngFor=\"let cartItem of cartItems\"> <span>{{cartItem.product.name}} ${{cartItem.product.price}} Qty:{{cartItem.quantity}} SubTotal:{{cartItem.quantity * cartItem.product.price}}</span> <!-- <button (click)=\"removeProduct(cartItem.index)\" style=\"font-weight:bold\">X</button> --> <span (click)=\"increaseQuantity(cartItem.index)\" class=\"glyphicon glyphicon-plus\"></span> <span (click)=\"decreaseQuantity(cartItem.index)\" class=\"glyphicon glyphicon-minus\"></span> </li> </ul> <span style=\"font-weight:bold;font-style:italic\">Total Before Tax:{{checkoutService.checkoutInfo.total_before_tax}}</span><br/> <span style=\"font-weight:bold;font-style:italic\">Tax :{{checkoutService.checkoutInfo.sales_tax}}</span><br/> <span style=\"font-weight:bold;font-style:italic\">Total After Tax :{{checkoutService.checkoutInfo.total_after_tax}}</span><br/> <span style=\"font-weight:bold;font-style:italic\">Shipping :{{checkoutService.checkoutInfo.shipping_cost}}</span><br/> <span style=\"font-weight:bold;font-style:italic\">Grand Total :{{checkoutService.checkoutInfo.grand_total}}</span><br/> <button (click)=\"goBack()\">Back</button> <button (click)=\"submitOrder()\">Submit Order</button> </div>",
    styles: ["label { display: inline-block; width: 3em; margin: .5em 0; color: #607D8B; font-weight: bold; } input { height: 2em; font-size: 1em; padding-left: .4em; } button { margin-top: 20px; font-family: Arial; background-color: #eee; border: none; padding: 5px 10px; border-radius: 4px; cursor: pointer; cursor: hand; } button:hover { background-color: #cfd8dc; } button:disabled { background-color: #eee; color: #ccc; cursor: auto; } .selected { border: double; border-width: thick; } .cart-items { list-style-type: none; }"]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: CartService, },
{type: Location, },
{type: Router, },
{type: CheckoutService, },
{type: LoggingService, },
];
}

function OrderSummaryComponent_tsickle_Closure_declarations() {
/** @type {?} */
OrderSummaryComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OrderSummaryComponent.ctorParameters;
/** @type {?} */
OrderSummaryComponent.prototype.cartItems;
/** @type {?} */
OrderSummaryComponent.prototype.cartGrandTotal;
/** @type {?} */
OrderSummaryComponent.prototype.cartService;
/** @type {?} */
OrderSummaryComponent.prototype.location;
/** @type {?} */
OrderSummaryComponent.prototype.router;
/** @type {?} */
OrderSummaryComponent.prototype.checkoutService;
/** @type {?} */
OrderSummaryComponent.prototype.loggingService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
